export default __webpack_public_path__ + "static/media/collections_2.b1886f90.jpg";